import { defineNuxtPlugin } from "#app";
export default defineNuxtPlugin(() => {
  if (typeof window === "undefined") return; // ✅ Vérifier si on est côté client

  const runtimeConfig = useRuntimeConfig();
  const paypalClientId =
    runtimeConfig.public.paypalClientId || process.env.PAYPAL_CLIENT_ID;

  if (!paypalClientId) {
    console.error("❌ PayPal Client ID manquant.");
    return;
  }

 // console.log(`🎯 PayPal ID chargé : ${paypalClientId}`);

  // Vérifie si le script est déjà chargé
  if (document.querySelector("script[src*='paypal.com/sdk/js']")) {
    console.log("✅ SDK PayPal déjà chargé !");
    return;
  }

  // Ajouter dynamiquement le script PayPal
  const script = document.createElement("script");
  script.src = `https://www.paypal.com/sdk/js?client-id=${paypalClientId}&currency=EUR`;
  script.async = true;
  script.onload = () => {
    console.log("✅ PayPal SDK chargé !");
  };
  document.head.appendChild(script);
});
